// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { getUrlPermissionId } from '../../app/routingSelector';

// Actions
import { associatePermissionIdToBoard } from '../../utils/permissions/permissionsActions';

const mapStateToProps = createStructuredSelector({
    queryPermissionId: getUrlPermissionId,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchAssociatePermissionIdToBoard: ({ permissionId, boardId }) =>
        dispatch(associatePermissionIdToBoard({ permissionId, boardId })),
});

let DispatchPermissionActionOnMount = (props) => {
    const { queryPermissionId, currentBoardId, dispatchAssociatePermissionIdToBoard } = props;

    React.useEffect(() => {
        if (!queryPermissionId) return;

        dispatchAssociatePermissionIdToBoard({ permissionId: queryPermissionId, boardId: currentBoardId });
    }, []);

    return null;
};

DispatchPermissionActionOnMount.propTypes = {
    currentBoardId: PropTypes.string,
    queryPermissionId: PropTypes.string,
    dispatchAssociatePermissionIdToBoard: PropTypes.func,
};

DispatchPermissionActionOnMount = connect(mapStateToProps, mapDispatchToProps)(DispatchPermissionActionOnMount);

const UrlBoardPermissionIdSynchroniser = (props) => {
    const { currentBoardId } = props;

    if (!currentBoardId) return null;

    return <DispatchPermissionActionOnMount currentBoardId={currentBoardId} />;
};

UrlBoardPermissionIdSynchroniser.propTypes = {
    currentBoardId: PropTypes.string,
};

export default UrlBoardPermissionIdSynchroniser;
